import { Store } from "@tanstack/react-store";
import { getDateWithOffset, recentPeriodToNoOfDays, normalizeDate } from "../utils/date";
import type { RecentPeriod } from "../types/date";

export type ChartDateRangeState = {
  startDate: Date;
  endDate: Date;
  quickSelect?: RecentPeriod;
};

function loadInitialState(): ChartDateRangeState {
  const quickSelect: RecentPeriod = "LAST_14";
  const noOfDays = recentPeriodToNoOfDays(quickSelect);
  const endDate = normalizeDate(getDateWithOffset(new Date(), -1));
  const startDate = normalizeDate(getDateWithOffset(endDate, -(noOfDays - 1)));

  return {
    startDate,
    endDate,
    quickSelect,
  };
}

export const chartDateRangeStore = new Store<ChartDateRangeState>(loadInitialState());

export const setChartDateRangeState = (state: ChartDateRangeState) => {
  chartDateRangeStore.setState((prev) => ({
    ...prev,
    startDate: normalizeDate(state.startDate),
    endDate: normalizeDate(state.endDate),
    quickSelect: state.quickSelect,
  }));
};
